import {Injectable, Injector} from '@angular/core';
import {Title} from '@angular/platform-browser';
import {RouterStateSnapshot, TitleStrategy} from '@angular/router';
import {Community} from '../_types/communities';
import {LocalStorageService} from './local-storage.service';
import {CommunitiesService} from './communities.service';

@Injectable()
export class AppTitlePrefix extends TitleStrategy {
    private lastPageTitle: string = '';
    private _communitiesService?: CommunitiesService;

    constructor(
        private titleService: Title,
        private localStorageService: LocalStorageService,
        private injector: Injector
    ) {
        super();
        // Lazily subscribe to communitiesService updates to break circular dependency
        setTimeout(() => {
            try {
                this._communitiesService = this.injector.get(CommunitiesService);
                this._communitiesService.getCurrentDashboardCommunity().subscribe((community): void => {
                    this.updateTitleWithCommunity(community);
                });
            } catch (e) {
                console.error('Failed to inject CommunitiesService in TitleStrategy', e);
            }
        });
    }

    updateTitle(snapshot: RouterStateSnapshot): void {
        this.lastPageTitle = this.buildTitle(snapshot) || '';
        const community: Community | null = this.localStorageService.getItem<Community | null>('lastSelectedCommunity', null);
        this.updateTitleWithCommunity(community);
    }

    private updateTitleWithCommunity(community: Community | null): void {
        if (this.lastPageTitle) {
            const communityName: string | null = community?.name ?? this.getCommunityNameFromSubdomain();
            this.titleService.setTitle(`${communityName} - ${this.lastPageTitle}`);
        }
    }

    private toTitleCase(str: string): string {
        return str
            .toLowerCase()
            .split(' ')
            .map(word => word.charAt(0).toUpperCase() + word.slice(1))
            .join(' ');
    }

    private getCommunityNameFromSubdomain(): string | null {
        const hostname: string = window.location.hostname.split('.')[0];
        return this.toTitleCase(hostname);
    }
}
